import React, {Component} from 'react';
import {Button, Modal, Form} from 'semantic-ui-react';
import update from 'react-addons-update';

import BranchOfficeData from "../../data/BranchOfficeData";
import MemberData from "../../data/MemberData";
import Toast from "../extras/Toast";
const C = require("../../constants");

class PermissionsDialog extends Component {

    constructor() {
        super();

        this.state = {
            open: false,
            data: {
                id: null,
                branch_office: {
                    id: '',
                    name: ''
                },
                user: {
                    type: '',
                    full_name: ''
                }
            },
            branch_office_error: false,
            branch_offices: [],
            type_error: false,
            index: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleType = this.handleType.bind(this);
        this.handleBranchOfficeChange = this.handleBranchOfficeChange.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
    }

    componentDidMount() {
        this.getBranchOffices();
    }

    async getBranchOffices() {
        let branch_offices = await BranchOfficeData.listAll();
        this.setState({branch_offices})
    }

    handleBranchOfficeChange = (result) => {
        let branch_office = update(this.state, {
            data: {
                branch_office: {
                    id: {
                        $set: result
                    },
                    name: {
                        $set: result
                    }
                }
            }
        });
        this.setState(branch_office);
        this.setState({branch_office_error: false})
    };

    handleType = (result) => {
        let type = update(this.state, {
            data: {
                user: {
                    type: {
                        $set: result
                    }
                }
            }
        });
        this.setState(type);
        this.setState({type_error: false})
    };

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.data.branch_office.id === '') {
            this.setState({branch_office_error: true});
        } else if (this.state.data.user.type === '') {
            this.setState({type_error: true});
        } else {
            let data = {
                id: this.state.data.id,
                branch_office: this.state.data.branch_office.id,
                type: this.state.data.user.type
            };
            this.setState({disabled_button: true});
            MemberData.permissions(data, (res) => {
                if (res.update) {
                    let branch_office = update(this.state, {
                        data: {
                            branch_office: {
                                id: {
                                    $set: res.branch_id
                                },
                                name: {
                                    $set: res.branch_name
                                }
                            }
                        }
                    });
                    this.setState(branch_office);
                    this.refs.toast.show({message: res.message, type: 'success'});
                    this.props.callbackUpdateData(this.state.data, this.state.index);
                    this.setState({disabled_button: false, open: false});
                } else {
                    this.refs.toast.show({message: res.message, type: 'error'});
                }
                this.setState({disabled_button: false});
            });
        }
    };

    handleOpen = (data, index) => {
        this.setState({open: true});
        this.setState({
            branch_office_error: false,
            type_error: false,
            data,
            open: true,
            index
        });
    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {
        return (
            <div>
                <Modal size='tiny' dimmer='inverted' open={this.state.open} onClose={this.handleClose}>
                    <Modal.Header>{`Cambiar Permisos - ${this.state.data.user.full_name}`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Select label='Sucursal' options={this.state.branch_offices}
                                             onChange={(e, {value}) => this.handleBranchOfficeChange(value)}
                                             value={this.state.data.branch_office.id} placeholder='Sucursal'
                                             error={this.state.branch_office_error}/>
                                <Form.Select label='Rol' options={C.USER_TYPES}
                                             onChange={(e, {value}) => this.handleType(value)}
                                             value={this.state.data.user.type} placeholder='Rol'
                                             error={this.state.type_error}/>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' loading={this.state.disabled_button} labelPosition='left'
                                onClick={this.handleSubmit} content='Actualizar permisos'/>
                    </Modal.Actions>
                </Modal>
                <Toast ref='toast'/>
            </div>
        );
    }
}

export default PermissionsDialog;



// WEBPACK FOOTER //
// ./src/components/security/PermissionsDialog.js